import { useSearchParams } from 'next/navigation';

import { SOURCE_PLATFORM_QUERY_PARAM_NAME } from '@/constant/routes';

import { useAppNavigationCtx, usePageDataCtx } from './ctx';

export const useCurrentPlatform = () => {
  const { metaPlatform, isCrossPlatform } = usePageDataCtx();
  const { activeAppNavigationItemByRoute } = useAppNavigationCtx();
  const sourcePlatform = useSearchParams().get(SOURCE_PLATFORM_QUERY_PARAM_NAME);

  if (activeAppNavigationItemByRoute) return activeAppNavigationItemByRoute.name;

  if (isCrossPlatform) {
    return sourcePlatform || metaPlatform;
  }
  return metaPlatform;
};
